// import { useMutation, useQuery } from "@tanstack/react-query";
import {  useQuery } from '@tanstack/react-query';
import { useStoreChoiceGroupApi } from '../../Hooks/useStoreChoiceGroupApi';


type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeId?: string;
};
export const useStoreChoiceGroup = (queryParams: Params) => {

  const { getStoreChoiceGroup } = useStoreChoiceGroupApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getChoiceGroup',queryParams],
    queryFn: () => {
      return getStoreChoiceGroup(queryParams);
    },
    // Avoid calling API with empty or undefined storeId
    enabled: Boolean(queryParams?.storeId && String(queryParams.storeId).trim().length > 0),
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};


